import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/icon_white.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/web-content/bless-pieces-full.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/blocks/bless-updates/bless-update.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/blocks/carousel/carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/blocks/drainproof-transacting/drainproof-transacting.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/blocks/key-apps/key-apps.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/blocks/landing-block/3d-logo/3d-logo-canvas.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/blocks/landing-block/feature-content/feature-content.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/blocks/landing-block/landing-block.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/blocks/landing-block/scroll-down-btn/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/blocks/landing-block/scroll-down-btn/scroll-target.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/blocks/stay-updated/stay-updated.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/layout/content-wrapper/content-wrapper.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/blocks/two-col-block/two-col-block.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/layout/gradient-background/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/layout/lines-background/lines-background.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/layout/navbar/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/layout/section-layout/section-layout.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/layout/page-positioner/page-positioner.module.scss");
